import WelcomeOrgLeagueSeason from '@/screens/WelcomeOrgLeagueSeason';

export default function PrivateWelcomeOrgLeagueSeasonRoute() {
  return <WelcomeOrgLeagueSeason />;
}
